var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal",class:{ 'is-active': _vm.is_active }},[_c('div',{staticClass:"modal-background"}),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-content"},[_c('progress',{staticClass:"progress is-large",attrs:{"max":"100"}})])
}]

export { render, staticRenderFns }